import { render, staticRenderFns } from "./LinkedExpenseRow.vue?vue&type=template&id=3b2f6f50&scoped=true"
import script from "./LinkedExpenseRow.vue?vue&type=script&lang=ts"
export * from "./LinkedExpenseRow.vue?vue&type=script&lang=ts"
import style0 from "./LinkedExpenseRow.vue?vue&type=style&index=0&id=3b2f6f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f6f50",
  null
  
)

export default component.exports